// * types
import type { UseFetchOptions } from "nuxt/app";
// * libs
import { defu } from "defu";

export const useApi = () => {
    const token = useCookie("access_token");
    const { openSnackbar } = useSnackbar();
    const _fetch = <T>(url: string | (() => string), options: UseFetchOptions<T> = {}) => {
        const config = useAppConfig() as any;
        const defaults: UseFetchOptions<T> = {
            key: url as string,
            baseURL: config.api.baseUrl as string,
            headers: token.value ? { Authorization: token.value } : {},
            watch: false,
            onResponse(_ctx) {},
            onRequestError(ctx) {
                // snackbarHandler({
                //   state: "error",
                //   description: ctx.error.message,
                // });
                Promise.reject(ctx.response);
            },
            onResponseError(ctx) {
                if (ctx.response.status === 408) {
                    openSnackbar({
                        state: "error",
                        description: "Timeout Occurred, Please Check you Connection and Retry",
                    });
                }
                // * if backend sends custom error in object (should be 'key' property in future for multilingual)
                if (ctx.response._data.error) {
                    // snackbarHandler({
                    //   state: "error",
                    //   description: ctx.response._data.error,
                    // });
                }
                // * if useFetch Returns a message
                else if (typeof ctx.response._data === "string") {
                    // snackbarHandler({
                    //   state: "error",
                    //   description: ctx.response._data,
                    // });
                }
                if (
                    ctx.response.status === 401 &&
                    ctx.response._data.key !== "api_error_invalid_credential" &&
                    !url.toString().includes("login") &&
                    !url.toString().includes("register")
                ) {
                    token.value = null;
                    location.replace("/");
                }
                Promise.reject(ctx.response);
            },
        };

        const params = defu(options, defaults);

        return useFetch(url, params);
    };

    const get = async (url: string, options?: UseFetchOptions<{}>) => {
        if (options) options.method = "GET";

        return await _fetch(url, { ...options });
    };

    const put = async (url: string, options?: UseFetchOptions<{}>) => {
        if (options) options.method = "PUT";

        return await _fetch(url, options);
    };

    const post = async (url: string, options?: UseFetchOptions<{}>) => {
        if (options) options.method = "POST";

        return await _fetch(url, options);
    };

    const del = async (url: string, options?: UseFetchOptions<{}>) => {
        if (options) options.method = "DELETE";

        return await _fetch(url, options);
    };

    return {
        get,
        put,
        post,
        del,
    };
};
